export const savePlayerMeta = async (
  { player, name, value, debugTag }
) => {
  await player.set("savePlayerMeta", { name, value, debugTag });
};

